import { dynamicImport } from '@core/helpers'
import { getCountryConfig } from '@core/helpers/countries'
import { ROUTES } from '@router'

export default ({ country, config }) => {
  const useNewUrl = config.FF_NEW_URL_FORMAT.includes(country)

  let routePath

  if (useNewUrl) {
    routePath = {
      // TODO => NEW_URL_TASK https://backmarket.atlassian.net/browse/URL-175
      [ROUTES.LANDING.MERCHANT]: '/s/:merchantName/:uuid',
      [ROUTES.LANDING.PRODUCT]: '/l/:slugV2(.*?)/:uuid',
    }
  } else {
    const countryConfig = getCountryConfig(country)
    const productLandingRegex = countryConfig.routesValidation.productLanding
    const merchantNameSpace = countryConfig.routesValidation.shop
    const merchantNameRegex = '[\\w_&-]{1,}'
    const merchantIdRegex = '[0-9]{1,}'

    routePath = {
      [ROUTES.LANDING
        .MERCHANT]: `/${merchantNameSpace}/:merchantName(${merchantNameRegex})-:id(${merchantIdRegex})`,
      [ROUTES.LANDING.PRODUCT]: `/:category(${productLandingRegex})`,
    }
  }

  return [
    {
      name: ROUTES.LANDING.SEARCH,
      path: '/search',
      component: () => dynamicImport(import('./pages/SearchLanding')),
    },
    {
      name: ROUTES.LANDING.MERCHANT,
      path: routePath[ROUTES.LANDING.MERCHANT],
      component: () => dynamicImport(import('./pages/MerchantLanding')),
    },
    {
      name: ROUTES.LANDING.PRODUCT,
      path: routePath[ROUTES.LANDING.PRODUCT],
      component: () => dynamicImport(import('./pages/ProductLanding')),
    },
    // REDIRECTING TO /search
    {
      name: 'filters',
      path: '/l/filters',
      component: () => dynamicImport(import('./pages/Filters')),
    },
    {
      name: ROUTES.LANDING.FILTERS_DETAILS,
      path: '/l/filters/:filter',
      component: () => dynamicImport(import('./pages/SubFilters')),
    },
    {
      name: ROUTES.LANDING.FILTERS_DETAILS_PRICE,
      path: '/l/filters/price',
      component: () => dynamicImport(import('./pages/PriceFilter')),
    },
    {
      name: ROUTES.LANDING.SORT,
      path: '/l/sort',
      component: () => dynamicImport(import('./pages/Sort')),
    },
  ]
}
